import Link from 'gatsby-link';
import React, { Component } from 'react';
import Zoom from 'react-reveal/Zoom';
import { Button, Container, Header, Responsive } from 'semantic-ui-react';

import GradientContainer from './GradientContainer';

export default class ContactSection extends Component {
  render() {
    return (
      <div>
        <GradientContainer textAlign="center">
          <Container style={{ margin: '3rem' }}>
            <Zoom>
              <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                <Header inverted content="Let’s Get Things Started!" className="mpost-header--huge inverted" textAlign="center" />
              </Responsive>
              <Responsive {...Responsive.onlyMobile}>
                <Header inverted content="Let’s Get Things Started!" className="mpost-header--huge mobile inverted" textAlign="center" />
              </Responsive>
              <br />
              <Button as={Link} to="/contact/" inverted content="CONTACT US" size="huge" />
            </Zoom>
          </Container>
        </GradientContainer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactSection.js